import React, { useState } from "react";
import styles from "./NavigationM.module.css";
import { Link } from "react-router-dom";
export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggle = () => {
    setIsMenuOpen(prev => !prev);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>Firma - mechanik</div>
      <ul className={`${styles.navLinks} ${isMenuOpen ? styles.active : ""}`}>
        <li>
          <a href="#hero">Strona główna</a>
        </li>
        <li>
          <a href="#aboutUs">O nas</a>
        </li>
        <li>
          <a href="#services">Usługi</a>
        </li>
        <li>
          <a href="#work">Jak pracujemy</a>
        </li>
        <li>
          <a href="#faq">FAQ</a>
        </li>
        {/* <li>
          <a href="#gallery">Galeria</a>
        </li> */}
        <li>
          <a href="#contact">Kontakt</a>
        </li>
        <li>
          <Link to="/vulcanization">Wulkanizacja</Link>
        </li>
      </ul>
      <div
        className={`${styles.menuToggle} ${isMenuOpen ? styles.open : ""}`}
        onClick={handleToggle}
      >
        <span />
        <span />
        <span />
      </div>
    </nav>
  );
}
